import { useTranslation } from 'react-i18next'

import { NotificationItemAdapter } from '@makyoapp/makyo-common'
import { ModalGrid, Twemoji } from '@makyoapp/makyo-ui'

import { MarkdownPreview } from '@/lib/markdown'

export interface NotifModalProps {
  notification: NotificationItemAdapter
  onHide: () => void
  show: boolean
}

export default function NotifModal({ notification, show, onHide }: NotifModalProps) {
  const { t } = useTranslation()

  return (
    <ModalGrid
      id={`${notification.id}-modal`}
      className='mk-notif-modal'
      show={show}
      onHide={onHide}
      onCancel={onHide}
      onConfirm={onHide}
      divProps={{
        'data-trigger-id': notification.trigger,
      }}
      title={
        <div className='flex-c'>
          <Twemoji className='p-0 w-5 h-5 notif-icon' emoji={notification.icon} />
          <div className='notif-title'>{notification.title}</div>
        </div>
      }
      leadingTitle={t('Cancel')}
      primaryTrailing={t('Ok')}
    >
      <div className='prose prose-xl dark:prose-invert notif-content'>
        <MarkdownPreview source={notification.content?.replaceAll('_blank', '')} />
      </div>
    </ModalGrid>
  )
}
